import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Grid,
  Chip
} from '@mui/material';
import { Source as SourceIcon } from '@mui/icons-material';

/**
 * DataSourcesInfo Component
 * 
 * Displays data sources information in a professional, client-facing format.
 * Shows the years and sources of data used in the AI summary.
 * 
 * @param {Array} sources - Array of source objects with label and value
 *   Example: [{ label: "Population Data", value: "Esri 2020, 2025, 2030" }]
 */
const DataSourcesInfo = ({ sources }) => {
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        backgroundColor: '#f8f9fa',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
        <SourceIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          Data Sources
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {sources.map((source, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box>
              <Typography variant="caption" sx={{ color: 'text.secondary', display: 'block', mb: 0.5 }}>
                {source.label}
              </Typography>
              <Chip
                label={source.value}
                size="small"
                variant="outlined"
                sx={{
                  backgroundColor: 'white',
                  fontWeight: 500,
                  fontSize: '0.75rem'
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Paper>
  );
};

export default DataSourcesInfo;

